export default __webpack_public_path__ + "static/media/madrona.ab2a6443.png";